import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    value: {
        user: ''
    }
}
const staffSlice = createSlice({
    name: "staffSlice",
    initialState,
    reducers: {
        staff: (state, action) => {
            state.value.user = action.payload
        },
    }
})
export const { staff } = staffSlice.actions
export default staffSlice.reducer